import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "../Login.css";
import bgImg from "../../../img/login image/job-search.jpg";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import Box from "@mui/material/Box";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import {
  Button,
  FormControl,
  FormHelperText,
  Grid,
  Tooltip,
  IconButton,
  InputAdornment,
  InputLabel,
  OutlinedInput,
  Typography,
} from "@mui/material";
import { useFormik } from "formik";
import * as Yup from "yup";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import useAxios from "../../../api/useAxios";
import ErrorSharpIcon from "@mui/icons-material/ErrorSharp";
import { ROUTINGDATA } from "../../ROUTINGDATA";


import Divider from "@mui/material/Divider";
import logo from "../../../img/logo_for-landingpage-3.png";



export default function ChangePassword(props) {
  const navigate = useNavigate();
  const [showOldPassword, setOldShowPassword] = useState(false);
  const [showNewPassword, setNewShowPassword] = useState(false);
  const [showConfirmPassword, setConformShowPassword] = useState(false);
  const NewPasswordBtn = () => setNewShowPassword((show) => !show);
  const OldPasswordBtn = () => setOldShowPassword((show) => !show);
  const ConfirmPasswordBtn = () => setConformShowPassword((show) => !show);
  let location = useLocation();
  const [open, setOpen] = React.useState(false);
  const [openOld, setOpenOld] = React.useState(false);
  const [openNew, setOpenNew] = React.useState(false);
  const axiosData = useAxios();
  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClickOpenOld = () => {
    setOpenOld(true);
  };
  const handleClickOpenNew = () => {
    setOpenNew(true);
  };
  const handleCloseNew = () => {
    setOpenNew(false);
  };
  const handleClose = () => {
    setOpen(false);
    navigate(`${ROUTINGDATA.LAND}${ROUTINGDATA.LOGIN}`);
  };
  const handleCloseOld = () => {
    setOpenOld(false);
  };
  const formik = useFormik({
    initialValues: {
      oldPassword: "",
      newPassword: "",
      confirmPassword: "",
    },
    validationSchema: Yup.object({
      oldPassword: Yup.string()
        .required("Required")
        .min(8, "Oldpassword is too short - should be 8 characters minimum."),
      newPassword: Yup.string()
        .required("Required")
        .min(8, "Newpassword is too short - should be 8 characters minimum.")
        .matches(
          /[a-zA-Z]/,
          "Password can only contain a combination of alphabets and numeric."
        ),

      confirmPassword: Yup.string()
        .required("Required")
        .oneOf([Yup.ref("newPassword"), null], "Passwords must match"),
    }),
    onSubmit: async (values, { resetForm }) => {
      const passwordNew = values.confirmPassword;
      const oldPassword = values.oldPassword;
      try {
        const resdata = await axiosData.post(
          "users/oldpassword",
          {
            email_id: location.state.email_id,
            oldPassword: oldPassword,
            passwordNew: passwordNew,
          },
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );

        if (resdata.data.message === "OldPassword Matched") {
          await axiosData.post(
            `users/${location.state.email_id}`,
            { password: passwordNew, oldPassword: oldPassword },
            {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            }
          );
          handleClickOpen();
        } else if (resdata.data.message === "OldPassword not Matched") {
          handleClickOpenOld();
          resetForm({ values: "" });
        } else if (resdata.data.message === "new and old password are same") {
          handleClickOpenNew();
          resetForm({ values: "" });
        }
      } catch (err) {
        console.log(err);
      }
      resetForm({ values: "" });
    },
  });

  return (
    <React.Fragment>
      <div id="forgotpasswordpage" className="forgotpasswordpage">
        <div className="forgotpasswordpage-logo-top">
          <div className="forgotpasswordimg">
            <img src={logo}  style={{cursor:"pointer"}}  onClick={() => navigate(`${ROUTINGDATA.LAND}${ROUTINGDATA.LOGIN}`)} />
          </div>
        </div>
        <div className="forgotpassword-input-box">
          <form onSubmit={formik.handleSubmit}>
            <div className="login-reg">
              <p>
                Welcome to{" "}
                <span>
                  <text>VELAI</text>VENDUM.com
                </span>
              </p>
            </div>
            <Divider />
            <div className="login-space">
              <div className="login-title">
                <h2>Change Password</h2>
              </div>
              <div className="forgotpassword-contect">
                <p>
                 Frist enter your old password and then enter your new password 
                </p>
              </div>
              <div className="space-forgotpassword">
              <div className="login-textfield-1">
                  <label>Old Password</label>
                  <OutlinedInput
                      size="small"
                      fullWidth
                      onChange={(e) => {
                        if (e) {
                          const value = e.target.value.replace(
                            /[^a-z0-9@$#₹]/gi,
                            ""
                          )
                          formik.setFieldValue("oldPassword", value);
                        }
                      }}
                      name="oldPassword"
                      value={formik.values.oldPassword}
                      onBlur={formik.handleBlur}
                      id="outlined-adornment-password"
                      type={showOldPassword ? "text" : "password"}
                      endAdornment={
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle password visibility"
                            onClick={OldPasswordBtn}
                            // onMouseDown={handleMouseDownPassword}
                            edge="end"
                          >
                            {showOldPassword ? (
                              <Tooltip title="hide">
                                <VisibilityOff fontSize="small" />
                              </Tooltip>
                            ) : null}
                            {!showOldPassword ? (
                              <Tooltip title="show">
                                <Visibility fontSize="small" />
                              </Tooltip>
                            ) : null}
                          </IconButton>
                        </InputAdornment>
                      }
                    />
                  <FormHelperText>
                  {formik.touched.oldPassword &&
                      formik.errors.oldPassword ? (
                        <Typography sx={{ color: "red", fontSize: "13px" }}>
                          {formik.errors.oldPassword}
                        </Typography>
                      ) : (
                        <Typography
                          sx={{ fontSize: "13px", visibility: "hidden" }}
                        >
                          none
                        </Typography>
                      )}
                  </FormHelperText>
                </div>
                <div className="login-textfield-1">
                  <label>New Password</label>
                  <OutlinedInput
                      size="small"
                      fullWidth
                      onChange={(e) => {
                        if (e) {
                          const value = e.target.value.replace(
                            /[^a-z0-9@$#₹]/gi,
                            ""
                          )
                          formik.setFieldValue("newPassword", value);
                        }
                      }}
                      name="newPassword"
                      value={formik.values.newPassword}
                      onBlur={formik.handleBlur}
                      id="outlined-adornment-password"
                      type={showNewPassword ? "text" : "password"}
                      endAdornment={
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle password visibility"
                            onClick={NewPasswordBtn}
                            // onMouseDown={handleMouseDownPassword}
                            edge="end"
                          >
                            {showNewPassword ? (
                              <Tooltip title="hide">
                                <VisibilityOff fontSize="small" />
                              </Tooltip>
                            ) : null}
                            {!showNewPassword ? (
                              <Tooltip title="show">
                                <Visibility fontSize="small" />
                              </Tooltip>
                            ) : null}
                          </IconButton>
                        </InputAdornment>
                      }
                    />
                  <FormHelperText>
                  {formik.touched.newPassword &&
                      formik.errors.newPassword ? (
                        <Typography sx={{ color: "red", fontSize: "13px" }}>
                          {formik.errors.newPassword}
                        </Typography>
                      ) : (
                        <Typography
                          sx={{ fontSize: "13px", visibility: "hidden" }}
                        >
                          none
                        </Typography>
                      )}
                  </FormHelperText>
                </div>
                <div className="login-textfield-1">
                  <label>Confirm Password</label>
                  <OutlinedInput
                      size="small"
                      fullWidth
                      onChange={(e) => {
                        if (e) {
                          const value = e.target.value.replace(
                            /[^a-z0-9@$#₹]/gi,
                            ""
                          )
                          formik.setFieldValue("confirmPassword", value);
                        }
                      }}
                      name="confirmPassword"
                      value={formik.values.confirmPassword}
                      onBlur={formik.handleBlur}
                      id="outlined-adornment-password"
                      type={showConfirmPassword ? "text" : "password"}
                      endAdornment={
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle password visibility"
                            onClick={ConfirmPasswordBtn}
                            // onMouseDown={handleMouseDownPassword}
                            edge="end"
                          >
                            {showConfirmPassword ? (
                              <Tooltip title="hide">
                                <VisibilityOff fontSize="small" />
                              </Tooltip>
                            ) : null}
                            {!showConfirmPassword ? (
                              <Tooltip title="show">
                                <Visibility fontSize="small" />
                              </Tooltip>
                            ) : null}
                          </IconButton>
                        </InputAdornment>
                      }
                    />
                  <FormHelperText>
                  {formik.touched.confirmPassword &&
                      formik.errors.confirmPassword ? (
                        <Typography sx={{ color: "red", fontSize: "13px" }}>
                          {formik.errors.confirmPassword}
                        </Typography>
                      ) : (
                        <Typography
                          sx={{ fontSize: "13px", visibility: "hidden" }}
                        >
                          none
                        </Typography>
                      )}
                  </FormHelperText>
                </div>
                <div className="loginbtn">
                  <Button variant="contained"   disabled={formik.isValid && formik.dirty ? false : true} fullWidth type="submit">
                  Update
                  </Button>
                </div>
              </div>
            </div>
          </form>
        </div>
        <Dialog
        open={openOld}
        sx={{
          "& .MuiPaper-root": {
            backgroundColor: "#339fcd",
            borderRadius: "10px",
            padding: "10px 10px",
          },
        }}
      >
        <Box>
          <DialogTitle sx={{ fontFamily: "Poppins-SemiBold" }}>
            <div style={{ display: "flex", gap: "3px", alignItems: "center" }}>
              <ErrorSharpIcon
                sx={{ mt: -0.3, color: "crimson" }}
                fontSize="large"
              />
              <Typography variant="h5" sx={{ ml: 0.3 }}>
                Old Password is Not match!
              </Typography>
            </div>
          </DialogTitle>
          <DialogContent>
            <DialogContentText
              sx={{ fontFamily: "Poppins-Medium", color: "crimson" }}
            >
              Go back and give your correct old Password again.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              variant="outlined"
              sx={{
                textTransform: "lowercase",
                color: "#ed1067",
                borderColor: "#ed1067",
                fontFamily: "Poppins-Medium",
                "&:hover": {
                  textTransform: "lowercase",
                  color: "white",
                  backgroundColor: "#ed1067",
                  borderColor: "#ed1067",
                  fontFamily: "Poppins-Medium",
                },
              }}
              onClick={() => {
                handleCloseOld();
              }}
            >
              Ok
            </Button>
          </DialogActions>
        </Box>
      </Dialog>
      <Dialog
        open={open}
        sx={{
          "& .MuiPaper-root": {
            backgroundColor: "#339fcd",
            borderRadius: "10px",
            padding: "10px 10px",
          },
        }}
      >
        <Box>
          <DialogTitle sx={{ fontFamily: "Poppins-SemiBold" }}>
            <div style={{ display: "flex", gap: "3px", alignItems: "center" }}>
              <CheckCircleIcon
                sx={{ mt: -0.3, color: "green" }}
                fontSize="large"
              />
              <Typography variant="h5" sx={{ ml: 0.3 }}>
                Password Changed Successfully!
              </Typography>
            </div>
          </DialogTitle>
          <DialogContent>
            <DialogContentText
              sx={{ fontFamily: "Poppins-Medium", color: "green" }}
            >
              Go back and Login again.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              variant="outlined"
              sx={{
                textTransform: "lowercase",
                color: "green",
                borderColor: "green",
                fontFamily: "Poppins-Medium",
                "&:hover": {
                  textTransform: "lowercase",
                  color: "white",
                  backgroundColor: "green",
                  borderColor: "green",
                  fontFamily: "Poppins-Medium",
                },
              }}
              onClick={() => {
                handleClose();
              }}
            >
              Ok
            </Button>
          </DialogActions>
        </Box>
      </Dialog>

      <Dialog
        open={openNew}
        sx={{
          "& .MuiPaper-root": {
            backgroundColor: "#339fcd",
            borderRadius: "10px",
            padding: "10px 10px",
          },
        }}
      >
        <Box>
          <DialogTitle sx={{ fontFamily: "Poppins-SemiBold" }}>
            <div style={{ display: "flex", gap: "3px", alignItems: "center" }}>
              <ErrorSharpIcon
                sx={{ mt: -0.3, color: "crimson" }}
                fontSize="large"
              />
              <Typography variant="h5" sx={{ ml: 0.3 }}>
                Old & New Password is Same!
              </Typography>
            </div>
          </DialogTitle>
          <DialogContent>
            <DialogContentText
              sx={{ fontFamily: "Poppins-Medium", color: "crimson" }}
            >
              Go back and give Your New Password.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              variant="outlined"
              sx={{
                textTransform: "lowercase",
                color: "#ed1067",
                borderColor: "#ed1067",
                fontFamily: "Poppins-Medium",
                "&:hover": {
                  textTransform: "lowercase",
                  color: "white",
                  backgroundColor: "#ed1067",
                  borderColor: "#ed1067",
                  fontFamily: "Poppins-Medium",
                },
              }}
              onClick={() => {
                handleCloseNew();
              }}
            >
              Ok
            </Button>
          </DialogActions>
        </Box>
      </Dialog>
      </div>
    </React.Fragment>
  );
}
